import React from 'react';

import classes from './ChallengePayment.module.scss';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { angularizeWithProviders } from '../../../../shared/providers';
import { ConnectStripeWidget } from '../../../containers/ConnectStripeWidget/ConnectStripeWidget';
import { ChallengeTaxWidget } from '../../../containers/ChallengeTaxWidget/ChallengeTaxWidget';

type ChallengePaymentProps = {
  entityId: number;
  isStripeConnected: boolean;
};

const ChallengePayment = ({ entityId, isStripeConnected }: ChallengePaymentProps) => {
  const { isSuperAdmin } = loggedInUserDataStore;

  return (
    <div className={classes.row}>
      <ConnectStripeWidget
        entityId={entityId}
        isStripeConnected={isStripeConnected}
        disabled={isSuperAdmin}
      />
      <ChallengeTaxWidget entityId={entityId} />
    </div>
  );
};

angularizeWithProviders(ChallengePayment, 'ngzChallengePaymentTab', {
  entityId: '<',
  isStripeConnected: '<',
});

export { ChallengePayment };
